export enum ETransportService {
  ASSEMBLING = 'Assembling',
  HUBS = 'Hubs',
  QUALITY_MANAGEMENT = 'Quality Management',
  VMI = 'VMI',
  WAREHOUSE = 'Warehouse',
}
